import classNames from 'classnames'
import MakerHubArticleContentBlock from '~/components/MakerHubArticleContentBlock'
import MakerHubArticleTitle from '~/components/MakerHubArticleTitle'
import MakerHubRelatedArticleList from '~/components/MakerHubRelatedArticleList'
import { SectionContainer } from '~/components/SectionContainer'
import { ToastProvider } from '~/providers/ToastProvider'
import { MakerHubArticleDetailProps } from './MakerHubArticleDetail.types'

export const MakerHubArticleDetail = ({
  article,
  relatedArticles,
  relatedProjects,
  width = 'narrow',
}: MakerHubArticleDetailProps) => {
  return (
    <SectionContainer
      innerClassName='lg:grid grid-cols-8 gap-4 mx-auto'
      wrapperClassName='mb-20'
      width={width}>
      <div className={classNames('col-span-5 pb-6 lg:pb-0')}>
        <ToastProvider>
          <MakerHubArticleTitle
            title={article.title}
            lastModifiedAt={article.lastModifiedAt}
          />
        </ToastProvider>
      </div>
      <div className={classNames('col-span-5')}>
        <MakerHubArticleContentBlock content={article.content} />
      </div>

      <div
        className={classNames(
          'col-span-3 px-0 lg:px-4 flex flex-col gap-10 pt-10 lg:pt-0'
        )}>
        {!!relatedArticles?.length && (
          <MakerHubRelatedArticleList
            title='Related Reads'
            articles={relatedArticles}
          />
        )}
        {!!relatedProjects?.length && (
          <MakerHubRelatedArticleList
            title='Related Projects'
            articles={relatedProjects}
          />
        )}
      </div>
    </SectionContainer>
  )
}
